"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var from_1 = require("rxjs/observable/from");
var LocalDatePipe = /** @class */ (function () {
    function LocalDatePipe(httpLocaleService, _currentLanguageProvider) {
        this.httpLocaleService = httpLocaleService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this.format = {
            date: 'date',
            dateTime: 'dateTime',
            time: 'time'
        };
    }
    LocalDatePipe.prototype.transform = function (date, format) {
        var _this = this;
        if (format === void 0) { format = this.format.date; }
        var currentLanguageObservable = this._currentLanguageProvider.getCurrentLanguage();
        if (date == null || date == undefined || typeof date !== "number") {
            return null;
        }
        switch (format) {
            case this.format.date:
                return currentLanguageObservable.pipe(operators_1.mergeMap(function (lang) { return from_1.from(_this.httpLocaleService.formatDate(date, lang.getId())); }));
            case this.format.dateTime:
                return currentLanguageObservable.pipe(operators_1.mergeMap(function (lang) { return from_1.from(_this.httpLocaleService.formatDateTime(date, lang.getId())); }));
            case this.format.time:
                return currentLanguageObservable.pipe(operators_1.mergeMap(function (lang) { return from_1.from(_this.httpLocaleService.formatTime(date, lang.getId())); }));
        }
    };
    LocalDatePipe = __decorate([
        core_1.Pipe({
            name: 'sysLocalDate'
        }),
        __metadata("design:paramtypes", [idm_locale_service_client_js_1.LocaleService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], LocalDatePipe);
    return LocalDatePipe;
}());
exports.LocalDatePipe = LocalDatePipe;
//# sourceMappingURL=local-date.pipe.js.map